export default __webpack_public_path__ + "static/media/1.392b8d03.png";